import { Popup, usePopup } from './Popup';
Popup.usePopup = usePopup;
export default Popup;
